import NextImage from "@/components/global/NextImage";
import CurrencyIcon from "@/components/icons/CurrencyIcon";
import TamaraModal from "@/components/modals/TamaraModal";
import { useState } from "react";

const TamaraWidget = ({ locale, amount, setSelected, fromPDP }) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <div
        onClick={() => {
          setShow(true);
          setSelected && setSelected("tamara");
        }}
        className="flex items-center gap-3 p-3 border rounded-md"
      >
        <NextImage
          width={85}
          height={28}
          className="w-16 md:w-[85px] h-7 object-contain"
          src={`/imgs/tamara-${locale}.svg`}
          alt="Tamara"
        />
        <span className="flex flex-wrap items-center gap-1 text-sm md:text-base">
          {locale === "ar" ? (
            <>
              <span>4 دفعات بقيمة </span>
              <span className="flex items-center gap-1 font-bold">
                {" "}
                {amount / 4} <CurrencyIcon className="size-4" />
              </span>{" "}
              <span> /شهر - متوافقة مع الشريعة، وبدون رسوم تأخير!.</span>
            </>
          ) : (
            <>
              <span>4 payments of</span>
              <span className="flex items-center gap-1 font-bold">
                {" "}
                <CurrencyIcon className="size-4" /> {amount / 4}
              </span>
              <span>/mo - No late fees, Sharia-compliant!.</span>
            </>
          )}
          <span className="text-sm font-bold underline cursor-pointer md:text-base">
            {locale === "ar" ? " اعرف أكثر" : " Learn more"}
          </span>
        </span>
      </div>
      <TamaraModal {...{ amount, locale, show, setShow, fromPDP }} />
    </>
  );
};

export default TamaraWidget;
